//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AreasClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined): Promise<PageResultOfAreaListItem> {
        let url_ = this.baseUrl + "/support/api/areas?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PageResultOfAreaListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfAreaListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfAreaListItem>(null as any);
    }

    updateArea(model: AreaUpdateItem): Promise<AreaItem> {
        let url_ = this.baseUrl + "/support/api/areas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArea(_response);
        });
    }

    protected processUpdateArea(response: Response): Promise<AreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaItem>(null as any);
    }

    anonymizeArea(id: number): Promise<AreaItem> {
        let url_ = this.baseUrl + "/support/api/areas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnonymizeArea(_response);
        });
    }

    protected processAnonymizeArea(response: Response): Promise<AreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaItem>(null as any);
    }

    getArea(id: number): Promise<AreaItem> {
        let url_ = this.baseUrl + "/support/api/areas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArea(_response);
        });
    }

    protected processGetArea(response: Response): Promise<AreaItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaItem>(null as any);
    }
}

export class GrandIdSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listGrandIdServices(): Promise<GrandIdServiceItem[]> {
        let url_ = this.baseUrl + "/support/api/grandidsettings/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListGrandIdServices(_response);
        });
    }

    protected processListGrandIdServices(response: Response): Promise<GrandIdServiceItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GrandIdServiceItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrandIdServiceItem[]>(null as any);
    }

    updateGrandIdService(model: GrandIdServiceUpdateItem): Promise<GrandIdServiceItem> {
        let url_ = this.baseUrl + "/support/api/grandidsettings/services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGrandIdService(_response);
        });
    }

    protected processUpdateGrandIdService(response: Response): Promise<GrandIdServiceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrandIdServiceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrandIdServiceItem>(null as any);
    }

    getGrandIdService(id: number): Promise<GrandIdServiceItem> {
        let url_ = this.baseUrl + "/support/api/grandidsettings/services/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGrandIdService(_response);
        });
    }

    protected processGetGrandIdService(response: Response): Promise<GrandIdServiceItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GrandIdServiceItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GrandIdServiceItem>(null as any);
    }
}

export class OpenUserImpersonationRequestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUserImpersonationRequest(impersonateUserId: number, impersonationRequestToken: string): Promise<UserImpersonationRequestInfoItem> {
        let url_ = this.baseUrl + "/support/api/openuserimpersonation/{impersonateUserId}/{impersonationRequestToken}";
        if (impersonateUserId === undefined || impersonateUserId === null)
            throw new Error("The parameter 'impersonateUserId' must be defined.");
        url_ = url_.replace("{impersonateUserId}", encodeURIComponent("" + impersonateUserId));
        if (impersonationRequestToken === undefined || impersonationRequestToken === null)
            throw new Error("The parameter 'impersonationRequestToken' must be defined.");
        url_ = url_.replace("{impersonationRequestToken}", encodeURIComponent("" + impersonationRequestToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserImpersonationRequest(_response);
        });
    }

    protected processGetUserImpersonationRequest(response: Response): Promise<UserImpersonationRequestInfoItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImpersonationRequestInfoItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImpersonationRequestInfoItem>(null as any);
    }

    denyUserImpersonationRequest(impersonateUserId: number, impersonationRequestToken: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/support/api/openuserimpersonation/reject/{impersonateUserId}/{impersonationRequestToken}";
        if (impersonateUserId === undefined || impersonateUserId === null)
            throw new Error("The parameter 'impersonateUserId' must be defined.");
        url_ = url_.replace("{impersonateUserId}", encodeURIComponent("" + impersonateUserId));
        if (impersonationRequestToken === undefined || impersonationRequestToken === null)
            throw new Error("The parameter 'impersonationRequestToken' must be defined.");
        url_ = url_.replace("{impersonationRequestToken}", encodeURIComponent("" + impersonationRequestToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDenyUserImpersonationRequest(_response);
        });
    }

    protected processDenyUserImpersonationRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    approveUserImpersonationRequest(impersonateUserId: number, impersonationRequestToken: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/support/api/openuserimpersonation/approve/{impersonateUserId}/{impersonationRequestToken}";
        if (impersonateUserId === undefined || impersonateUserId === null)
            throw new Error("The parameter 'impersonateUserId' must be defined.");
        url_ = url_.replace("{impersonateUserId}", encodeURIComponent("" + impersonateUserId));
        if (impersonationRequestToken === undefined || impersonationRequestToken === null)
            throw new Error("The parameter 'impersonationRequestToken' must be defined.");
        url_ = url_.replace("{impersonationRequestToken}", encodeURIComponent("" + impersonationRequestToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveUserImpersonationRequest(_response);
        });
    }

    protected processApproveUserImpersonationRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class OrganizationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined): Promise<PageResultOfOrganizationListItem> {
        let url_ = this.baseUrl + "/support/api/organizations?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PageResultOfOrganizationListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfOrganizationListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfOrganizationListItem>(null as any);
    }

    updateOrganization(model: OrganizationUpdateItem): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/support/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOrganization(_response);
        });
    }

    protected processUpdateOrganization(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }

    anonymizeOrganization(id: number): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/support/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnonymizeOrganization(_response);
        });
    }

    protected processAnonymizeOrganization(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }

    getOrganization(id: number): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/support/api/organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrganization(_response);
        });
    }

    protected processGetOrganization(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }

    persistOrganizationGrandIdSetting(model: OrganizationGrandIdSettingPersistItem): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/support/api/organizations/organization/grandIdSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPersistOrganizationGrandIdSetting(_response);
        });
    }

    protected processPersistOrganizationGrandIdSetting(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }

    deleteOrganizationGrandIdSetting(id: number): Promise<OrganizationItem> {
        let url_ = this.baseUrl + "/support/api/organizations/organization/grandIdSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOrganizationGrandIdSetting(_response);
        });
    }

    protected processDeleteOrganizationGrandIdSetting(response: Response): Promise<OrganizationItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationItem>(null as any);
    }
}

export class UserImpersonationRequestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listUserImpersonationRequests(): Promise<UserImpersonationRequestListItem[]> {
        let url_ = this.baseUrl + "/support/api/userimpersonation/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListUserImpersonationRequests(_response);
        });
    }

    protected processListUserImpersonationRequests(response: Response): Promise<UserImpersonationRequestListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserImpersonationRequestListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImpersonationRequestListItem[]>(null as any);
    }

    getUserImpersonationRequest(id: number): Promise<UserImpersonationRequestItem> {
        let url_ = this.baseUrl + "/support/api/userimpersonation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserImpersonationRequest(_response);
        });
    }

    protected processGetUserImpersonationRequest(response: Response): Promise<UserImpersonationRequestItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImpersonationRequestItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImpersonationRequestItem>(null as any);
    }

    abandonUserImpersonationRequest(id: number): Promise<UserImpersonationRequestItem> {
        let url_ = this.baseUrl + "/support/api/userimpersonation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAbandonUserImpersonationRequest(_response);
        });
    }

    protected processAbandonUserImpersonationRequest(response: Response): Promise<UserImpersonationRequestItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImpersonationRequestItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImpersonationRequestItem>(null as any);
    }

    deleteUserImpersonationRequest(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/support/api/userimpersonation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserImpersonationRequest(_response);
        });
    }

    protected processDeleteUserImpersonationRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createUserImpersonationRequest(model: UserImpersonationRequestCreateItem): Promise<UserImpersonationRequestItem> {
        let url_ = this.baseUrl + "/support/api/userimpersonation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUserImpersonationRequest(_response);
        });
    }

    protected processCreateUserImpersonationRequest(response: Response): Promise<UserImpersonationRequestItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImpersonationRequestItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImpersonationRequestItem>(null as any);
    }

    getActiveUserImpersonationRequest(userId: number): Promise<UserImpersonationRequestItem> {
        let url_ = this.baseUrl + "/support/api/userimpersonation/activeRequest/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveUserImpersonationRequest(_response);
        });
    }

    protected processGetActiveUserImpersonationRequest(response: Response): Promise<UserImpersonationRequestItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImpersonationRequestItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImpersonationRequestItem>(null as any);
    }

    generateJwtTokenForUserImpersonationRequest(id: number): Promise<JwtTokenGenerationResultItem> {
        let url_ = this.baseUrl + "/support/api/userimpersonation/generateJwtTokenForUserImpersonationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJwtTokenForUserImpersonationRequest(_response);
        });
    }

    protected processGenerateJwtTokenForUserImpersonationRequest(response: Response): Promise<JwtTokenGenerationResultItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtTokenGenerationResultItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtTokenGenerationResultItem>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(page: number | undefined, pageSize: number | undefined, organizationId: number | null | undefined, areaId: number | null | undefined): Promise<PageResultOfUserListItem> {
        let url_ = this.baseUrl + "/support/api/users?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (areaId !== undefined && areaId !== null)
            url_ += "AreaId=" + encodeURIComponent("" + areaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PageResultOfUserListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfUserListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfUserListItem>(null as any);
    }

    updateUser(model: UserUpdateItem): Promise<UserItem> {
        let url_ = this.baseUrl + "/support/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserItem>(null as any);
    }

    getUser(id: number): Promise<UserItem> {
        let url_ = this.baseUrl + "/support/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserItem>(null as any);
    }
}

export class VersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAppVersion(): Promise<string> {
        let url_ = this.baseUrl + "/support/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppVersion(_response);
        });
    }

    protected processGetAppVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export abstract class PageResult implements IPageResult {
    page!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PageResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PageResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPageResult {
    page: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PageResultOfAreaListItem extends PageResult implements IPageResultOfAreaListItem {
    items!: AreaListItem[];
    searchOptions!: PageSearchOptions;

    constructor(data?: IPageResultOfAreaListItem) {
        super(data);
        if (!data) {
            this.items = [];
            this.searchOptions = new PageSearchOptions();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AreaListItem.fromJS(item));
            }
            this.searchOptions = _data["searchOptions"] ? PageSearchOptions.fromJS(_data["searchOptions"]) : new PageSearchOptions();
        }
    }

    static fromJS(data: any): PageResultOfAreaListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfAreaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["searchOptions"] = this.searchOptions ? this.searchOptions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPageResultOfAreaListItem extends IPageResult {
    items: AreaListItem[];
    searchOptions: PageSearchOptions;
}

export class AreaListItem implements IAreaListItem {
    id!: number;
    name!: string;
    organizationId!: number;
    organizationName!: string;
    active!: boolean;
    performAutoSign!: boolean;
    organizationParentsName!: string;

    constructor(data?: IAreaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.active = _data["active"];
            this.performAutoSign = _data["performAutoSign"];
            this.organizationParentsName = _data["organizationParentsName"];
        }
    }

    static fromJS(data: any): AreaListItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["active"] = this.active;
        data["performAutoSign"] = this.performAutoSign;
        data["organizationParentsName"] = this.organizationParentsName;
        return data;
    }
}

export interface IAreaListItem {
    id: number;
    name: string;
    organizationId: number;
    organizationName: string;
    active: boolean;
    performAutoSign: boolean;
    organizationParentsName: string;
}

export class PageSearchOptions implements IPageSearchOptions {
    page!: number;
    pageSize!: number;
    organizationId?: number | undefined;
    areaId?: number | undefined;

    constructor(data?: IPageSearchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.organizationId = _data["organizationId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): PageSearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new PageSearchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["organizationId"] = this.organizationId;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface IPageSearchOptions {
    page: number;
    pageSize: number;
    organizationId?: number | undefined;
    areaId?: number | undefined;
}

export class AreaItem implements IAreaItem {
    id!: number;
    name!: string;
    organizationId!: number;
    organizationName!: string;
    active!: boolean;
    performAutoSign!: boolean;
    organizationParentsName!: string;
    dateForAutoSigningTurnOff?: Date | undefined;
    isAnonymized!: boolean;

    constructor(data?: IAreaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.active = _data["active"];
            this.performAutoSign = _data["performAutoSign"];
            this.organizationParentsName = _data["organizationParentsName"];
            this.dateForAutoSigningTurnOff = _data["dateForAutoSigningTurnOff"] ? new Date(_data["dateForAutoSigningTurnOff"].toString()) : <any>undefined;
            this.isAnonymized = _data["isAnonymized"];
        }
    }

    static fromJS(data: any): AreaItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["active"] = this.active;
        data["performAutoSign"] = this.performAutoSign;
        data["organizationParentsName"] = this.organizationParentsName;
        data["dateForAutoSigningTurnOff"] = this.dateForAutoSigningTurnOff ? this.dateForAutoSigningTurnOff.toISOString() : <any>undefined;
        data["isAnonymized"] = this.isAnonymized;
        return data;
    }
}

export interface IAreaItem {
    id: number;
    name: string;
    organizationId: number;
    organizationName: string;
    active: boolean;
    performAutoSign: boolean;
    organizationParentsName: string;
    dateForAutoSigningTurnOff?: Date | undefined;
    isAnonymized: boolean;
}

export class AreaUpdateItem implements IAreaUpdateItem {
    id!: number;
    active!: boolean;
    performAutoSign!: boolean;
    dateForAutoSigningTurnOff?: Date | undefined;

    constructor(data?: IAreaUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.performAutoSign = _data["performAutoSign"];
            this.dateForAutoSigningTurnOff = _data["dateForAutoSigningTurnOff"] ? new Date(_data["dateForAutoSigningTurnOff"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AreaUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new AreaUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["performAutoSign"] = this.performAutoSign;
        data["dateForAutoSigningTurnOff"] = this.dateForAutoSigningTurnOff ? this.dateForAutoSigningTurnOff.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAreaUpdateItem {
    id: number;
    active: boolean;
    performAutoSign: boolean;
    dateForAutoSigningTurnOff?: Date | undefined;
}

export class GrandIdServiceItem implements IGrandIdServiceItem {
    id!: number;
    value!: string;
    authenticateServiceKey?: string;
    active!: boolean;

    constructor(data?: IGrandIdServiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.authenticateServiceKey = _data["authenticateServiceKey"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): GrandIdServiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new GrandIdServiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["authenticateServiceKey"] = this.authenticateServiceKey;
        data["active"] = this.active;
        return data;
    }
}

export interface IGrandIdServiceItem {
    id: number;
    value: string;
    authenticateServiceKey?: string;
    active: boolean;
}

export class GrandIdServiceUpdateItem implements IGrandIdServiceUpdateItem {
    id!: number;
    value!: string;
    authenticateServiceKey?: string;
    active!: boolean;

    constructor(data?: IGrandIdServiceUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.authenticateServiceKey = _data["authenticateServiceKey"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): GrandIdServiceUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new GrandIdServiceUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["authenticateServiceKey"] = this.authenticateServiceKey;
        data["active"] = this.active;
        return data;
    }
}

export interface IGrandIdServiceUpdateItem {
    id: number;
    value: string;
    authenticateServiceKey?: string;
    active: boolean;
}

export class UserImpersonationRequestInfoItem implements IUserImpersonationRequestInfoItem {
    requestedOn!: Date;
    requestedByFullname!: string;

    constructor(data?: IUserImpersonationRequestInfoItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : <any>undefined;
            this.requestedByFullname = _data["requestedByFullname"];
        }
    }

    static fromJS(data: any): UserImpersonationRequestInfoItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationRequestInfoItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        data["requestedByFullname"] = this.requestedByFullname;
        return data;
    }
}

export interface IUserImpersonationRequestInfoItem {
    requestedOn: Date;
    requestedByFullname: string;
}

export class PageResultOfOrganizationListItem extends PageResult implements IPageResultOfOrganizationListItem {
    items!: OrganizationListItem[];
    searchOptions!: PageSearchOptions;

    constructor(data?: IPageResultOfOrganizationListItem) {
        super(data);
        if (!data) {
            this.items = [];
            this.searchOptions = new PageSearchOptions();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationListItem.fromJS(item));
            }
            this.searchOptions = _data["searchOptions"] ? PageSearchOptions.fromJS(_data["searchOptions"]) : new PageSearchOptions();
        }
    }

    static fromJS(data: any): PageResultOfOrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfOrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["searchOptions"] = this.searchOptions ? this.searchOptions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPageResultOfOrganizationListItem extends IPageResult {
    items: OrganizationListItem[];
    searchOptions: PageSearchOptions;
}

export class OrganizationListItem implements IOrganizationListItem {
    id!: number;
    name!: string;
    active!: boolean;

    constructor(data?: IOrganizationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): OrganizationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        return data;
    }
}

export interface IOrganizationListItem {
    id: number;
    name: string;
    active: boolean;
}

export class OrganizationItem implements IOrganizationItem {
    id!: number;
    name!: string;
    registrationNumber!: string;
    expectedEmailDomain!: string;
    active!: boolean;
    customerPausedPeriodDaysHorizon!: number;
    expiringDelegationsWeeksHorizon!: number;
    allowSigningWhenDelegationsIsNotFulfilled!: boolean;
    allowStartedActivityStatus!: boolean;
    allowAreaTemplateActivities!: boolean;
    allowCommentOnSigning!: boolean;
    useDelegations!: boolean;
    useDrugLists!: boolean;
    useWorkSchedule!: boolean;
    deviceIpRange?: string | undefined;
    isAnonymized!: boolean;
    grandIdOrganizationIdentifier?: string | undefined;
    organizationGrandIdSettings?: OrganizationGrandIdSettingItem[];
    allowStandardLogin!: boolean;
    useLoginSlidingExpirationMinutes!: boolean;
    loginSlidingExpirationMinutes?: number | undefined;

    constructor(data?: IOrganizationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.registrationNumber = _data["registrationNumber"];
            this.expectedEmailDomain = _data["expectedEmailDomain"];
            this.active = _data["active"];
            this.customerPausedPeriodDaysHorizon = _data["customerPausedPeriodDaysHorizon"];
            this.expiringDelegationsWeeksHorizon = _data["expiringDelegationsWeeksHorizon"];
            this.allowSigningWhenDelegationsIsNotFulfilled = _data["allowSigningWhenDelegationsIsNotFulfilled"];
            this.allowStartedActivityStatus = _data["allowStartedActivityStatus"];
            this.allowAreaTemplateActivities = _data["allowAreaTemplateActivities"];
            this.allowCommentOnSigning = _data["allowCommentOnSigning"];
            this.useDelegations = _data["useDelegations"];
            this.useDrugLists = _data["useDrugLists"];
            this.useWorkSchedule = _data["useWorkSchedule"];
            this.deviceIpRange = _data["deviceIpRange"];
            this.isAnonymized = _data["isAnonymized"];
            this.grandIdOrganizationIdentifier = _data["grandIdOrganizationIdentifier"];
            if (Array.isArray(_data["organizationGrandIdSettings"])) {
                this.organizationGrandIdSettings = [] as any;
                for (let item of _data["organizationGrandIdSettings"])
                    this.organizationGrandIdSettings!.push(OrganizationGrandIdSettingItem.fromJS(item));
            }
            this.allowStandardLogin = _data["allowStandardLogin"];
            this.useLoginSlidingExpirationMinutes = _data["useLoginSlidingExpirationMinutes"];
            this.loginSlidingExpirationMinutes = _data["loginSlidingExpirationMinutes"];
        }
    }

    static fromJS(data: any): OrganizationItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["registrationNumber"] = this.registrationNumber;
        data["expectedEmailDomain"] = this.expectedEmailDomain;
        data["active"] = this.active;
        data["customerPausedPeriodDaysHorizon"] = this.customerPausedPeriodDaysHorizon;
        data["expiringDelegationsWeeksHorizon"] = this.expiringDelegationsWeeksHorizon;
        data["allowSigningWhenDelegationsIsNotFulfilled"] = this.allowSigningWhenDelegationsIsNotFulfilled;
        data["allowStartedActivityStatus"] = this.allowStartedActivityStatus;
        data["allowAreaTemplateActivities"] = this.allowAreaTemplateActivities;
        data["allowCommentOnSigning"] = this.allowCommentOnSigning;
        data["useDelegations"] = this.useDelegations;
        data["useDrugLists"] = this.useDrugLists;
        data["useWorkSchedule"] = this.useWorkSchedule;
        data["deviceIpRange"] = this.deviceIpRange;
        data["isAnonymized"] = this.isAnonymized;
        data["grandIdOrganizationIdentifier"] = this.grandIdOrganizationIdentifier;
        if (Array.isArray(this.organizationGrandIdSettings)) {
            data["organizationGrandIdSettings"] = [];
            for (let item of this.organizationGrandIdSettings)
                data["organizationGrandIdSettings"].push(item.toJSON());
        }
        data["allowStandardLogin"] = this.allowStandardLogin;
        data["useLoginSlidingExpirationMinutes"] = this.useLoginSlidingExpirationMinutes;
        data["loginSlidingExpirationMinutes"] = this.loginSlidingExpirationMinutes;
        return data;
    }
}

export interface IOrganizationItem {
    id: number;
    name: string;
    registrationNumber: string;
    expectedEmailDomain: string;
    active: boolean;
    customerPausedPeriodDaysHorizon: number;
    expiringDelegationsWeeksHorizon: number;
    allowSigningWhenDelegationsIsNotFulfilled: boolean;
    allowStartedActivityStatus: boolean;
    allowAreaTemplateActivities: boolean;
    allowCommentOnSigning: boolean;
    useDelegations: boolean;
    useDrugLists: boolean;
    useWorkSchedule: boolean;
    deviceIpRange?: string | undefined;
    isAnonymized: boolean;
    grandIdOrganizationIdentifier?: string | undefined;
    organizationGrandIdSettings?: OrganizationGrandIdSettingItem[];
    allowStandardLogin: boolean;
    useLoginSlidingExpirationMinutes: boolean;
    loginSlidingExpirationMinutes?: number | undefined;
}

export class OrganizationGrandIdSettingItem implements IOrganizationGrandIdSettingItem {
    id!: number;
    organizationId!: number;
    grandIdServiceId?: GrandIdServiceEnum | undefined;
    grandIdParameterId?: GrandIdParameterEnum | undefined;
    parameterValue!: string;

    constructor(data?: IOrganizationGrandIdSettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.grandIdServiceId = _data["grandIdServiceId"];
            this.grandIdParameterId = _data["grandIdParameterId"];
            this.parameterValue = _data["parameterValue"];
        }
    }

    static fromJS(data: any): OrganizationGrandIdSettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationGrandIdSettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["grandIdServiceId"] = this.grandIdServiceId;
        data["grandIdParameterId"] = this.grandIdParameterId;
        data["parameterValue"] = this.parameterValue;
        return data;
    }
}

export interface IOrganizationGrandIdSettingItem {
    id: number;
    organizationId: number;
    grandIdServiceId?: GrandIdServiceEnum | undefined;
    grandIdParameterId?: GrandIdParameterEnum | undefined;
    parameterValue: string;
}

export enum GrandIdServiceEnum {
    Saml = "Saml",
    FrejaEId = "FrejaEId",
    BankId = "BankId",
}

export enum GrandIdParameterEnum {
    ApiKey = "ApiKey",
}

export class OrganizationUpdateItem implements IOrganizationUpdateItem {
    id!: number;
    name!: string;
    registrationNumber!: string;
    expectedEmailDomain!: string;
    active!: boolean;
    customerPausedPeriodDaysHorizon!: number;
    expiringDelegationsWeeksHorizon!: number;
    allowSigningWhenDelegationsIsNotFulfilled!: boolean;
    allowStartedActivityStatus!: boolean;
    allowAreaTemplateActivities!: boolean;
    allowCommentOnSigning!: boolean;
    useDelegations!: boolean;
    useDrugLists!: boolean;
    useWorkSchedule!: boolean;
    deviceIpRange?: string | undefined;
    grandIdOrganizationIdentifier?: string | undefined;
    allowStandardLogin!: boolean;
    useLoginSlidingExpirationMinutes!: boolean;
    loginSlidingExpirationMinutes?: number | undefined;

    constructor(data?: IOrganizationUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.registrationNumber = _data["registrationNumber"];
            this.expectedEmailDomain = _data["expectedEmailDomain"];
            this.active = _data["active"];
            this.customerPausedPeriodDaysHorizon = _data["customerPausedPeriodDaysHorizon"];
            this.expiringDelegationsWeeksHorizon = _data["expiringDelegationsWeeksHorizon"];
            this.allowSigningWhenDelegationsIsNotFulfilled = _data["allowSigningWhenDelegationsIsNotFulfilled"];
            this.allowStartedActivityStatus = _data["allowStartedActivityStatus"];
            this.allowAreaTemplateActivities = _data["allowAreaTemplateActivities"];
            this.allowCommentOnSigning = _data["allowCommentOnSigning"];
            this.useDelegations = _data["useDelegations"];
            this.useDrugLists = _data["useDrugLists"];
            this.useWorkSchedule = _data["useWorkSchedule"];
            this.deviceIpRange = _data["deviceIpRange"];
            this.grandIdOrganizationIdentifier = _data["grandIdOrganizationIdentifier"];
            this.allowStandardLogin = _data["allowStandardLogin"];
            this.useLoginSlidingExpirationMinutes = _data["useLoginSlidingExpirationMinutes"];
            this.loginSlidingExpirationMinutes = _data["loginSlidingExpirationMinutes"];
        }
    }

    static fromJS(data: any): OrganizationUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["registrationNumber"] = this.registrationNumber;
        data["expectedEmailDomain"] = this.expectedEmailDomain;
        data["active"] = this.active;
        data["customerPausedPeriodDaysHorizon"] = this.customerPausedPeriodDaysHorizon;
        data["expiringDelegationsWeeksHorizon"] = this.expiringDelegationsWeeksHorizon;
        data["allowSigningWhenDelegationsIsNotFulfilled"] = this.allowSigningWhenDelegationsIsNotFulfilled;
        data["allowStartedActivityStatus"] = this.allowStartedActivityStatus;
        data["allowAreaTemplateActivities"] = this.allowAreaTemplateActivities;
        data["allowCommentOnSigning"] = this.allowCommentOnSigning;
        data["useDelegations"] = this.useDelegations;
        data["useDrugLists"] = this.useDrugLists;
        data["useWorkSchedule"] = this.useWorkSchedule;
        data["deviceIpRange"] = this.deviceIpRange;
        data["grandIdOrganizationIdentifier"] = this.grandIdOrganizationIdentifier;
        data["allowStandardLogin"] = this.allowStandardLogin;
        data["useLoginSlidingExpirationMinutes"] = this.useLoginSlidingExpirationMinutes;
        data["loginSlidingExpirationMinutes"] = this.loginSlidingExpirationMinutes;
        return data;
    }
}

export interface IOrganizationUpdateItem {
    id: number;
    name: string;
    registrationNumber: string;
    expectedEmailDomain: string;
    active: boolean;
    customerPausedPeriodDaysHorizon: number;
    expiringDelegationsWeeksHorizon: number;
    allowSigningWhenDelegationsIsNotFulfilled: boolean;
    allowStartedActivityStatus: boolean;
    allowAreaTemplateActivities: boolean;
    allowCommentOnSigning: boolean;
    useDelegations: boolean;
    useDrugLists: boolean;
    useWorkSchedule: boolean;
    deviceIpRange?: string | undefined;
    grandIdOrganizationIdentifier?: string | undefined;
    allowStandardLogin: boolean;
    useLoginSlidingExpirationMinutes: boolean;
    loginSlidingExpirationMinutes?: number | undefined;
}

export class OrganizationGrandIdSettingPersistItem implements IOrganizationGrandIdSettingPersistItem {
    id?: number | undefined;
    organizationId!: number;
    grandIdServiceId!: GrandIdServiceEnum;
    grandIdParameterId!: GrandIdParameterEnum;
    parameterValue!: string;

    constructor(data?: IOrganizationGrandIdSettingPersistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.grandIdServiceId = _data["grandIdServiceId"];
            this.grandIdParameterId = _data["grandIdParameterId"];
            this.parameterValue = _data["parameterValue"];
        }
    }

    static fromJS(data: any): OrganizationGrandIdSettingPersistItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationGrandIdSettingPersistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["grandIdServiceId"] = this.grandIdServiceId;
        data["grandIdParameterId"] = this.grandIdParameterId;
        data["parameterValue"] = this.parameterValue;
        return data;
    }
}

export interface IOrganizationGrandIdSettingPersistItem {
    id?: number | undefined;
    organizationId: number;
    grandIdServiceId: GrandIdServiceEnum;
    grandIdParameterId: GrandIdParameterEnum;
    parameterValue: string;
}

export class UserImpersonationRequestListItem implements IUserImpersonationRequestListItem {
    id!: number;
    impersonateUserId!: number;
    impersonateUser!: UserItem;
    requestedOn!: Date;
    statusId!: UserImpersonationRequestStatusEnum;
    status!: UserImpersonationRequestStatus;
    sessionApprovedOn?: Date | undefined;
    sessionDeniedOn?: Date | undefined;
    sessionExpiresOn?: Date | undefined;
    sessionAbandonedOn?: Date | undefined;

    constructor(data?: IUserImpersonationRequestListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.impersonateUser = new UserItem();
            this.status = new UserImpersonationRequestStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.impersonateUserId = _data["impersonateUserId"];
            this.impersonateUser = _data["impersonateUser"] ? UserItem.fromJS(_data["impersonateUser"]) : new UserItem();
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? UserImpersonationRequestStatus.fromJS(_data["status"]) : new UserImpersonationRequestStatus();
            this.sessionApprovedOn = _data["sessionApprovedOn"] ? new Date(_data["sessionApprovedOn"].toString()) : <any>undefined;
            this.sessionDeniedOn = _data["sessionDeniedOn"] ? new Date(_data["sessionDeniedOn"].toString()) : <any>undefined;
            this.sessionExpiresOn = _data["sessionExpiresOn"] ? new Date(_data["sessionExpiresOn"].toString()) : <any>undefined;
            this.sessionAbandonedOn = _data["sessionAbandonedOn"] ? new Date(_data["sessionAbandonedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserImpersonationRequestListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationRequestListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["impersonateUserId"] = this.impersonateUserId;
        data["impersonateUser"] = this.impersonateUser ? this.impersonateUser.toJSON() : <any>undefined;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["sessionApprovedOn"] = this.sessionApprovedOn ? this.sessionApprovedOn.toISOString() : <any>undefined;
        data["sessionDeniedOn"] = this.sessionDeniedOn ? this.sessionDeniedOn.toISOString() : <any>undefined;
        data["sessionExpiresOn"] = this.sessionExpiresOn ? this.sessionExpiresOn.toISOString() : <any>undefined;
        data["sessionAbandonedOn"] = this.sessionAbandonedOn ? this.sessionAbandonedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserImpersonationRequestListItem {
    id: number;
    impersonateUserId: number;
    impersonateUser: UserItem;
    requestedOn: Date;
    statusId: UserImpersonationRequestStatusEnum;
    status: UserImpersonationRequestStatus;
    sessionApprovedOn?: Date | undefined;
    sessionDeniedOn?: Date | undefined;
    sessionExpiresOn?: Date | undefined;
    sessionAbandonedOn?: Date | undefined;
}

export class UserItem implements IUserItem {
    id!: number;
    active!: boolean;
    firstName!: string;
    lastName!: string;
    fullName!: string;
    email!: string;
    phoneNumber!: string;
    organizationId!: number;
    organizationName!: string;
    userAreas!: UserAreaListItem[];
    userTypeId!: UserTypeEnum;

    constructor(data?: IUserItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userAreas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            if (Array.isArray(_data["userAreas"])) {
                this.userAreas = [] as any;
                for (let item of _data["userAreas"])
                    this.userAreas!.push(UserAreaListItem.fromJS(item));
            }
            this.userTypeId = _data["userTypeId"];
        }
    }

    static fromJS(data: any): UserItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        if (Array.isArray(this.userAreas)) {
            data["userAreas"] = [];
            for (let item of this.userAreas)
                data["userAreas"].push(item.toJSON());
        }
        data["userTypeId"] = this.userTypeId;
        return data;
    }
}

export interface IUserItem {
    id: number;
    active: boolean;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    phoneNumber: string;
    organizationId: number;
    organizationName: string;
    userAreas: UserAreaListItem[];
    userTypeId: UserTypeEnum;
}

export class UserAreaListItem implements IUserAreaListItem {
    id!: number;
    roleId!: RoleEnum;
    areaId!: number;
    areaName!: string;
    organizationParentsName!: string;

    constructor(data?: IUserAreaListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.organizationParentsName = _data["organizationParentsName"];
        }
    }

    static fromJS(data: any): UserAreaListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserAreaListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["organizationParentsName"] = this.organizationParentsName;
        return data;
    }
}

export interface IUserAreaListItem {
    id: number;
    roleId: RoleEnum;
    areaId: number;
    areaName: string;
    organizationParentsName: string;
}

export enum RoleEnum {
    Admin = "Admin",
    Planner = "Planner",
    Caretaker = "Caretaker",
}

export enum UserTypeEnum {
    SystemAdmin = "SystemAdmin",
    OrganizationMember = "OrganizationMember",
    OrganizationAdmin = "OrganizationAdmin",
    TeniloSupport = "TeniloSupport",
}

export enum UserImpersonationRequestStatusEnum {
    AwaitingApproval = "AwaitingApproval",
    Approved = "Approved",
    Denied = "Denied",
    Abandoned = "Abandoned",
    Expired = "Expired",
}

export class UserImpersonationRequestStatus implements IUserImpersonationRequestStatus {
    id!: UserImpersonationRequestStatusEnum;
    value!: string;

    constructor(data?: IUserImpersonationRequestStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UserImpersonationRequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationRequestStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IUserImpersonationRequestStatus {
    id: UserImpersonationRequestStatusEnum;
    value: string;
}

export class UserImpersonationRequestItem implements IUserImpersonationRequestItem {
    id!: number;
    impersonateUserId!: number;
    impersonateUser!: UserItem;
    requestedOn!: Date;
    statusId!: UserImpersonationRequestStatusEnum;
    status!: UserImpersonationRequestStatus;
    sessionApprovedOn?: Date | undefined;
    sessionDeniedOn?: Date | undefined;
    sessionExpiresOn?: Date | undefined;
    sessionAbandonedOn?: Date | undefined;

    constructor(data?: IUserImpersonationRequestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.impersonateUser = new UserItem();
            this.status = new UserImpersonationRequestStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.impersonateUserId = _data["impersonateUserId"];
            this.impersonateUser = _data["impersonateUser"] ? UserItem.fromJS(_data["impersonateUser"]) : new UserItem();
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? UserImpersonationRequestStatus.fromJS(_data["status"]) : new UserImpersonationRequestStatus();
            this.sessionApprovedOn = _data["sessionApprovedOn"] ? new Date(_data["sessionApprovedOn"].toString()) : <any>undefined;
            this.sessionDeniedOn = _data["sessionDeniedOn"] ? new Date(_data["sessionDeniedOn"].toString()) : <any>undefined;
            this.sessionExpiresOn = _data["sessionExpiresOn"] ? new Date(_data["sessionExpiresOn"].toString()) : <any>undefined;
            this.sessionAbandonedOn = _data["sessionAbandonedOn"] ? new Date(_data["sessionAbandonedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserImpersonationRequestItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationRequestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["impersonateUserId"] = this.impersonateUserId;
        data["impersonateUser"] = this.impersonateUser ? this.impersonateUser.toJSON() : <any>undefined;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["sessionApprovedOn"] = this.sessionApprovedOn ? this.sessionApprovedOn.toISOString() : <any>undefined;
        data["sessionDeniedOn"] = this.sessionDeniedOn ? this.sessionDeniedOn.toISOString() : <any>undefined;
        data["sessionExpiresOn"] = this.sessionExpiresOn ? this.sessionExpiresOn.toISOString() : <any>undefined;
        data["sessionAbandonedOn"] = this.sessionAbandonedOn ? this.sessionAbandonedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserImpersonationRequestItem {
    id: number;
    impersonateUserId: number;
    impersonateUser: UserItem;
    requestedOn: Date;
    statusId: UserImpersonationRequestStatusEnum;
    status: UserImpersonationRequestStatus;
    sessionApprovedOn?: Date | undefined;
    sessionDeniedOn?: Date | undefined;
    sessionExpiresOn?: Date | undefined;
    sessionAbandonedOn?: Date | undefined;
}

export class UserImpersonationRequestCreateItem implements IUserImpersonationRequestCreateItem {
    impersonateUserId!: number;

    constructor(data?: IUserImpersonationRequestCreateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonateUserId = _data["impersonateUserId"];
        }
    }

    static fromJS(data: any): UserImpersonationRequestCreateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationRequestCreateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonateUserId"] = this.impersonateUserId;
        return data;
    }
}

export interface IUserImpersonationRequestCreateItem {
    impersonateUserId: number;
}

export class JwtTokenGenerationResultItem implements IJwtTokenGenerationResultItem {
    token!: string;
    tokenExpiresOn!: Date;
    refreshToken!: string;
    refreshTokenExpiresOn!: Date;

    constructor(data?: IJwtTokenGenerationResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpiresOn = _data["tokenExpiresOn"] ? new Date(_data["tokenExpiresOn"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiresOn = _data["refreshTokenExpiresOn"] ? new Date(_data["refreshTokenExpiresOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JwtTokenGenerationResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new JwtTokenGenerationResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpiresOn"] = this.tokenExpiresOn ? this.tokenExpiresOn.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiresOn"] = this.refreshTokenExpiresOn ? this.refreshTokenExpiresOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJwtTokenGenerationResultItem {
    token: string;
    tokenExpiresOn: Date;
    refreshToken: string;
    refreshTokenExpiresOn: Date;
}

export class PageResultOfUserListItem extends PageResult implements IPageResultOfUserListItem {
    items!: UserListItem[];
    searchOptions!: PageSearchOptions;

    constructor(data?: IPageResultOfUserListItem) {
        super(data);
        if (!data) {
            this.items = [];
            this.searchOptions = new PageSearchOptions();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListItem.fromJS(item));
            }
            this.searchOptions = _data["searchOptions"] ? PageSearchOptions.fromJS(_data["searchOptions"]) : new PageSearchOptions();
        }
    }

    static fromJS(data: any): PageResultOfUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfUserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["searchOptions"] = this.searchOptions ? this.searchOptions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPageResultOfUserListItem extends IPageResult {
    items: UserListItem[];
    searchOptions: PageSearchOptions;
}

export class UserListItem implements IUserListItem {
    id!: number;
    active!: boolean;
    firstName!: string;
    lastName!: string;
    fullName!: string;
    email!: string;
    phoneNumber!: string;
    organizationId!: number;
    organizationName!: string;
    userTypeId!: UserTypeEnum;
    userAreas!: UserAreaListItem[];
    userImpersonationRequests!: ActiveUserImpersonationRequestListItem[];

    constructor(data?: IUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userAreas = [];
            this.userImpersonationRequests = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.userTypeId = _data["userTypeId"];
            if (Array.isArray(_data["userAreas"])) {
                this.userAreas = [] as any;
                for (let item of _data["userAreas"])
                    this.userAreas!.push(UserAreaListItem.fromJS(item));
            }
            if (Array.isArray(_data["userImpersonationRequests"])) {
                this.userImpersonationRequests = [] as any;
                for (let item of _data["userImpersonationRequests"])
                    this.userImpersonationRequests!.push(ActiveUserImpersonationRequestListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["userTypeId"] = this.userTypeId;
        if (Array.isArray(this.userAreas)) {
            data["userAreas"] = [];
            for (let item of this.userAreas)
                data["userAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.userImpersonationRequests)) {
            data["userImpersonationRequests"] = [];
            for (let item of this.userImpersonationRequests)
                data["userImpersonationRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserListItem {
    id: number;
    active: boolean;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    phoneNumber: string;
    organizationId: number;
    organizationName: string;
    userTypeId: UserTypeEnum;
    userAreas: UserAreaListItem[];
    userImpersonationRequests: ActiveUserImpersonationRequestListItem[];
}

export class ActiveUserImpersonationRequestListItem implements IActiveUserImpersonationRequestListItem {
    id!: number;
    requestedOn!: Date;
    statusId!: UserImpersonationRequestStatusEnum;
    status!: UserImpersonationRequestStatus;
    sessionApprovedOn?: Date | undefined;
    sessionDeniedOn?: Date | undefined;
    sessionExpiresOn?: Date | undefined;
    sessionAbandonedOn?: Date | undefined;

    constructor(data?: IActiveUserImpersonationRequestListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = new UserImpersonationRequestStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? UserImpersonationRequestStatus.fromJS(_data["status"]) : new UserImpersonationRequestStatus();
            this.sessionApprovedOn = _data["sessionApprovedOn"] ? new Date(_data["sessionApprovedOn"].toString()) : <any>undefined;
            this.sessionDeniedOn = _data["sessionDeniedOn"] ? new Date(_data["sessionDeniedOn"].toString()) : <any>undefined;
            this.sessionExpiresOn = _data["sessionExpiresOn"] ? new Date(_data["sessionExpiresOn"].toString()) : <any>undefined;
            this.sessionAbandonedOn = _data["sessionAbandonedOn"] ? new Date(_data["sessionAbandonedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveUserImpersonationRequestListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserImpersonationRequestListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["sessionApprovedOn"] = this.sessionApprovedOn ? this.sessionApprovedOn.toISOString() : <any>undefined;
        data["sessionDeniedOn"] = this.sessionDeniedOn ? this.sessionDeniedOn.toISOString() : <any>undefined;
        data["sessionExpiresOn"] = this.sessionExpiresOn ? this.sessionExpiresOn.toISOString() : <any>undefined;
        data["sessionAbandonedOn"] = this.sessionAbandonedOn ? this.sessionAbandonedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActiveUserImpersonationRequestListItem {
    id: number;
    requestedOn: Date;
    statusId: UserImpersonationRequestStatusEnum;
    status: UserImpersonationRequestStatus;
    sessionApprovedOn?: Date | undefined;
    sessionDeniedOn?: Date | undefined;
    sessionExpiresOn?: Date | undefined;
    sessionAbandonedOn?: Date | undefined;
}

export class UserUpdateItem implements IUserUpdateItem {
    id!: number;
    userTypeId!: UserTypeEnum;

    constructor(data?: IUserUpdateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userTypeId = _data["userTypeId"];
        }
    }

    static fromJS(data: any): UserUpdateItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userTypeId"] = this.userTypeId;
        return data;
    }
}

export interface IUserUpdateItem {
    id: number;
    userTypeId: UserTypeEnum;
}

export abstract class ServiceError implements IServiceError {

    constructor(data?: IServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceError {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ServiceError' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceError {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}